import { useIsFetching, useIsMutating, Query, Mutation } from "@tanstack/react-query"

function filterQuery(query: Query | Mutation) {
  const meta = query.meta || {}

  return !meta.isDisabledLoading
}

export function useQueryFetching() {
  const fetchingQueryNumber = useIsFetching({ predicate: filterQuery })
  const mutingQueryNumber = useIsMutating({ predicate: filterQuery })

  return !!fetchingQueryNumber || !!mutingQueryNumber
}
